import React from 'react';
import { Link } from 'react-router-dom';
import autoBind from 'react-autobind';
import { ToolbarGroup } from 'material-ui/Toolbar';
import Popover from 'material-ui/Popover';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import DropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ContentAdd from 'material-ui/svg-icons/content/add';
import KeyboardTab from 'material-ui/svg-icons/hardware/keyboard-tab';
import { List, ListItem } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import Hamburger from 'material-ui/svg-icons/navigation/menu';
import NewFacility from '../NewFacility';

import style from './style.js';

class FacilityDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false,
      modalOpen: false
    };
    autoBind(this);
  }

  openPopover(event) {
    // prevDefault prevents "ghost click", as per Popover docs
    event.preventDefault();
    this.setState({
      popoverOpen: true,
      anchorEl: event.currentTarget
    });
  }

  closePopover() {
    this.setState({ popoverOpen: false });
  }

  openFacilityModal() {
    this.setState({ modalOpen: true, popoverOpen: false });
  }

  closeFacilityModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const { facilities, currentUser } = this.props;
    const { permissions } = currentUser;

    return (
      <div>
        <FlatButton
          style={{ maxWidth: 260 }}
          hoverColor="rgba(255, 255, 255, 0.3)"
          labelStyle={{ color: '#fff' }}
          onClick={this.openPopover}
          label="Select a Facility"
          labelPosition="before"
          icon={<DropDownIcon style={{ marginRight: 0 }} color={'#fff'} />}
        />
        <Popover
          open={this.state.popoverOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.closePopover}
        >
          <List>
            {facilities.map((facility, index) => (
              <div key={facility._id}>
                <ListItem
                  onClick={this.closePopover}
                  primaryText={facility.name}
                  secondaryText={facility.address}
                  secondaryTextLines={1}
                  containerElement={<Link to={`/map/${facility._id}`} />}
                />
                <Divider />
              </div>
            ))}
            {permissions.edit.resources && (
              <ListItem
                onClick={this.openFacilityModal}
                rightIcon={<ContentAdd />}
                primaryText="New Facility"
              />
            )}
          </List>
        </Popover>
        {permissions.edit.resources &&
          this.state.modalOpen && (
            <NewFacility
              open
              onRequestClose={this.closeFacilityModal}
              checkCanAdd="facilities"
            />
          )}
      </div>
    );
  }
}

export default class FacilityBar extends React.Component {
  render() {
    const { facilities, sidebarOpen, toggleSidebar, currentUser } = this.props;
    return (
      <ToolbarGroup style={style.headerWide}>
        <div onClick={toggleSidebar}>
          <IconButton
            iconStyle={{ color: 'white' }}
            style={{ transform: 'rotate(180deg)' }}
          >
            {sidebarOpen ? <KeyboardTab /> : <Hamburger />}
          </IconButton>
        </div>
        <FacilityDropDown facilities={facilities} currentUser={currentUser} />
      </ToolbarGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NavBar/FacilityBar.js